import { Navigate } from 'react-router-dom';
import { clearSession, getSession } from '@/lib/session';
import { normalizeRole } from '@/auth/permissions';
import { getHomePathForRole } from '@/utils/roleRouting';
import { canUseEmployeeHome } from '@/utils/employeeHome';

export default function AutoHome() {
  const session = typeof window !== 'undefined' ? getSession() : null;
  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') clearSession();
    return <Navigate to="/login" replace />;
  }
  const role = normalizeRole(session.user.role);
  const home = role === 'RH'
    ? '/admin/rh'
    : canUseEmployeeHome(session.user.email, session.user.role, session.user.isInternal) ? '/home' : getHomePathForRole(session.user.role);
  return <Navigate to={home} replace />;
}
